import React from 'react';
import PropTypes from 'prop-types';
import filter from 'lodash/filter';
import pluralize from 'pluralize';

import ProjectCard from 'components/project/project_card';
import ListingRollup from './listing_rollup';
import { ListGroup } from 'react-bootstrap-5';

export default class ListingRollupSummary extends React.Component {
  static propTypes = {
    editLink: PropTypes.string.isRequired,
    features: PropTypes.shape({
      backoffice: PropTypes.bool,
      pipeline: PropTypes.bool,
    }).isRequired,
    listings: PropTypes.arrayOf(PropTypes.shape({
      listingStatus: PropTypes.string
    })).isRequired,
    listingType: PropTypes.string
  };

  listings(status) {
    return filter(this.props.listings, ({ listingStatus }) => listingStatus === status);
  }

  listingRollup(name, status) {
    const listings = this.listings(status);

    if (listings.length === 0) return;

    return (
      <ListGroup.Item className="flex-column align-items-stretch">
        <ListingRollup
          editLink={this.props.editLink}
          features={this.props.features}
          listings={this.listings(status)}
          listingType={this.props.listingType}
          name={name}
          status={status}
        />
      </ListGroup.Item>
    );
  }

  render() {
    if (!this.props.listings) return;

    return (
      <ProjectCard bare={true} name={pluralize(this.props.listingType)}>
        <ListGroup variant="flush">
          {this.listingRollup('proposal', 'proposal')}
          {this.listingRollup('on-market', 'on_market')}
          {this.listingRollup('under-contract', 'under_contract')}
          {this.listingRollup('closed', 'closed')}
          {this.listingRollup('off-market', 'off_market')}
        </ListGroup>
      </ProjectCard>
    );
  }
}
